<template>
    <div class="scancode-wrapper center">
        <div class="msg">长按即可保存</div>

        <div class="scancode">
            <div class="scan-bg">
                <van-image class="bg" src="/img/scancode_bg.png?v=2" @load="createPayImage">
                    <van-image class="qrcode" :src="qrcode" @load="createPayImage">
<!--                        <img class="logo" src="~@/assets/img/logo.png" @load="createPayImage" />-->
                    </van-image>
                    <div class="activity">
                        <div>{{ remark }}</div>
                        <!-- <div>{{ remark.split("|")[1] }}</div> -->
                    </div>
                </van-image>
            </div>
            <img class="pay-image" :src="payImage" />
        </div>
    </div> 
</template>

<script>
import QRcode from "qrcode";
import html2canvas from "html2canvas";

export default {
    data() {
        return {
            qrcode: "",
            payImage: "",
            remark: ""
        }
    },
    methods: {
        createPayImage() {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				setTimeout(() => {
					const imgDom = document.querySelector('.scancode .bg');
					new html2canvas(imgDom, {
						allowTaint: false,
						useCORS: true,
						background: "#ffffff",
						width: imgDom.offsetWidth, // canvas宽度
						height: imgDom.offsetHeight, // canvas高度
						async: false,
						dpi: 300
					}).then(canvas => {	
						this.payImage = canvas.toDataURL("image/png");
                        this.toast && this.toast.clear();
					})
				}, 30);
			}, 500);
		}
    },
    async created() {
        let { link, remark } = this.$route.query;
        if (!link) return this.$toast("缺少link参数！");
        try {
            link = globalThis.atob(link);
        } catch (error) {
            return this.$toast("请先使用base64转换");
        }   
        this.remark = remark || "";

        this.toast = this.$toast.loading({
            message: "生成中...",
            forbidClick: true,
            loadingType: 'spinner',
        });

        const qrcode = await QRcode.toDataURL(link, {
            width: 1000,
            height: 1000,
            version: 10,
            errorCorrectionLevel: 'Q',
            margin: 1,
            color: {
                dark: "#000",
                light: "#fff"
            },
        })
        this.qrcode = qrcode;
    }
}
</script>

<style lang="less" scoped>
.center {
    display: flex;
    justify-content: center;
    align-items: center;
}

/deep/ .van-image {
    display: block;
}
/deep/ img {
    display: block;
}

.scancode-wrapper {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    max-width: 688px;
    max-height: 100vh;
    position: relative;
    overflow: hidden;
    .msg {
        position: absolute;
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #000;
        top: 10px;
        left: 0;
        z-index: 1;
    }
}
.scancode {
    width: 100%;
}

.scan-bg {
    position: relative;
    width: 100%;    
    height: 100%;
}
.bg {
    width: 100%;
    height: 100%;
    text-align: center;
    color: #000;
    font-size: 14px;
}
/deep/ .activity {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 50%;
    padding-top: 50%;
    transform: translate(-50%, -50%);
}
.qrcode {
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -45%);
    width: 45%;
    height: 0;
    padding-top: 45%;
    /deep/ .van-image__img {
        position: absolute;
        left: 0;
        top: 0;
    }
    .logo {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 20%;
        height: 20%;
    }
}
.pay-image {
    position: absolute;
    width: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
}
</style>